var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-alert",
        {
          staticClass: "intro",
          attrs: { type: "warning", closable: false, "show-icon": "" },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("adminUsers.introTitle"))),
          ]),
          _c("div", {
            staticClass: "intro-body",
            domProps: { innerHTML: _vm._s(_vm.$t("adminUsers.introBody")) },
          }),
        ]
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: { label: _vm.$t("adminUsers.tabSingle"), name: "single" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, md: 11 } },
                    [
                      _c(
                        "el-card",
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_vm._v(_vm._s(_vm.$t("adminUsers.newUser")))]
                          ),
                          _c(
                            "el-form",
                            {
                              ref: "form",
                              attrs: {
                                model: _vm.form,
                                rules: _vm.rules,
                                "label-position": "top",
                              },
                              nativeOn: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.submit.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("adminUsers.email"),
                                    prop: "email",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "adminUsers.emailPlaceholder"
                                      ),
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.form.email,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "email", $$v)
                                      },
                                      expression: "form.email",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                { attrs: { gutter: 12 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "adminUsers.firstName"
                                            ),
                                            prop: "firstName",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { clearable: "" },
                                            model: {
                                              value: _vm.form.firstName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "firstName",
                                                  $$v
                                                )
                                              },
                                              expression: "form.firstName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "adminUsers.lastName"
                                            ),
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { clearable: "" },
                                            model: {
                                              value: _vm.form.lastName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "lastName",
                                                  $$v
                                                )
                                              },
                                              expression: "form.lastName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                { attrs: { gutter: 12 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 10 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "adminUsers.countryCode"
                                            ),
                                            prop: "countryCode",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "adminUsers.countryCodePlaceholder"
                                              ),
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.form.countryCode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "countryCode",
                                                  $$v
                                                )
                                              },
                                              expression: "form.countryCode",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 14 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t("adminUsers.phone"),
                                            prop: "phoneNumber",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "adminUsers.optional"
                                              ),
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.form.phoneNumber,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "phoneNumber",
                                                  $$v
                                                )
                                              },
                                              expression: "form.phoneNumber",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "hint" }, [
                                _vm._v(_vm._s(_vm.$t("adminUsers.phoneHint"))),
                              ]),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-plus",
                                        loading: _vm.loading,
                                      },
                                      on: { click: _vm.submit },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("adminUsers.create")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    { on: { click: _vm.resetForm } },
                                    [_vm._v(_vm._s(_vm.$t("adminUsers.clear")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, md: 13 } },
                    [
                      _c(
                        "el-card",
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("adminUsers.createdThisSession")
                                  ) +
                                  " "
                              ),
                              _vm.created.length
                                ? _c("span", { staticClass: "count" }, [
                                    _vm._v(
                                      "(" + _vm._s(_vm.created.length) + ")"
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          !_vm.created.length
                            ? _c("el-empty", {
                                attrs: {
                                  description: _vm.$t("adminUsers.noneYet"),
                                },
                              })
                            : _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.created,
                                    border: "",
                                    fit: "",
                                    size: "small",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("adminUsers.email"),
                                      "min-width": "220",
                                      prop: "email",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("adminUsers.fullName"),
                                      "min-width": "160",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function ({ row }) {
                                          return [
                                            _vm._v(
                                              _vm._s(row.firstName) +
                                                " " +
                                                _vm._s(row.lastName)
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: _vm.$t("adminUsers.userId"),
                                      "min-width": "200",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function ({ row }) {
                                          return [
                                            _c(
                                              "span",
                                              { staticClass: "mono" },
                                              [_vm._v(_vm._s(row.userId))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("adminUsers.tabBulk"), name: "bulk" } },
            [
              _c(
                "el-card",
                [
                  _c(
                    "div",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("adminUsers.bulkStep1")) + " "
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "tpl-btn",
                          attrs: { type: "text", icon: "el-icon-download" },
                          on: { click: _vm.downloadTemplate },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("adminUsers.downloadTemplate")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "hint" }, [
                    _vm._v(_vm._s(_vm.$t("adminUsers.bulkColumnsHint"))),
                  ]),
                  _c(
                    "el-table",
                    {
                      staticClass: "col-docs",
                      attrs: {
                        data: _vm.columnDocs,
                        border: "",
                        fit: "",
                        size: "mini",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("adminUsers.colColumn"),
                          width: "150",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("span", { staticClass: "mono" }, [
                                  _vm._v(_vm._s(row.key)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("adminUsers.colRequired"),
                          width: "110",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: row.required ? "danger" : "info",
                                      size: "mini",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          row.required
                                            ? _vm.$t("adminUsers.required")
                                            : _vm.$t("adminUsers.optional")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("adminUsers.colMeaning"),
                          "min-width": "260",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [_vm._v(_vm._s(_vm.$t(row.desc)))]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { staticClass: "bulk-card" },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _vm._v(_vm._s(_vm.$t("adminUsers.bulkStep2"))),
                  ]),
                  _c("upload-excel", {
                    attrs: {
                      "before-upload": _vm.beforeExcelUpload,
                      "on-success": _vm.handleExcelSuccess,
                    },
                  }),
                ],
                1
              ),
              _vm.rows.length
                ? _c(
                    "el-card",
                    { staticClass: "bulk-card" },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("adminUsers.bulkStep3")) + " "
                        ),
                        _c("span", { staticClass: "count" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("adminUsers.bulkSummary", {
                                  ready: _vm.readyRows.length,
                                  invalid: _vm.invalidRows.length,
                                })
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                      _vm.invalidRows.length
                        ? _c("el-alert", {
                            staticClass: "skip-note",
                            attrs: {
                              type: "info",
                              closable: false,
                              "show-icon": "",
                              title: _vm.$t("adminUsers.invalidSkipped"),
                            },
                          })
                        : _vm._e(),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.rows,
                            border: "",
                            fit: "",
                            size: "small",
                            "max-height": "420",
                            "row-class-name": _vm.rowClass,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("adminUsers.rowNo"),
                              width: "70",
                              align: "center",
                              prop: "rowNo",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("adminUsers.email"),
                              "min-width": "210",
                              prop: "email",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("adminUsers.fullName"),
                              "min-width": "150",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _vm._v(
                                        _vm._s(row.firstName) +
                                          " " +
                                          _vm._s(row.lastName)
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4232953478
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("adminUsers.phone"),
                              "min-width": "130",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      row.phoneNumber
                                        ? _c("span", [
                                            _vm._v(
                                              "+" +
                                                _vm._s(row.countryCode) +
                                                " " +
                                                _vm._s(row.phoneNumber)
                                            ),
                                          ])
                                        : _c("span", { staticClass: "muted" }, [
                                            _vm._v("-"),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3123475965
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("adminUsers.status"),
                              "min-width": "230",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: _vm.statusTag(row.status),
                                            size: "mini",
                                            effect: "dark",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "adminUsers.status_" +
                                                    row.status
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      row.message
                                        ? _c("div", { staticClass: "reason" }, [
                                            _vm._v(_vm._s(row.message)),
                                          ])
                                        : _vm._e(),
                                      row.userId
                                        ? _c(
                                            "div",
                                            { staticClass: "reason mono" },
                                            [_vm._v(_vm._s(row.userId))]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              200522389
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "bulk-actions" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-plus",
                                loading: _vm.bulkRunning,
                                disabled: !_vm.readyRows.length,
                              },
                              on: { click: _vm.confirmBulk },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("adminUsers.createN", {
                                      n: _vm.readyRows.length,
                                    })
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm.finishedRows.length
                            ? _c(
                                "el-button",
                                {
                                  attrs: { icon: "el-icon-download" },
                                  on: { click: _vm.downloadResults },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("adminUsers.downloadResults")
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: { disabled: _vm.bulkRunning },
                              on: { click: _vm.clearBulk },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("adminUsers.clear")) + " "
                              ),
                            ]
                          ),
                          _vm.bulkRunning
                            ? _c("el-progress", {
                                staticClass: "progress",
                                attrs: {
                                  percentage: _vm.progressPercent,
                                  "stroke-width": 14,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }